import { combineReducers } from 'redux';

import { userWatchersUniqueIdsReducer } from './userWatchersUniqueIds';
import { userWatchersMapReducer } from './userWatchersMap';
import { watchersCountsMapReducer } from './watchersCountsMap';
import { watchersKeysReducer } from './watchersKeys';
import { watchersQueriesMapReducer } from './watchersQueriesMap';
import { watcherExistsReducer } from './watcherExists';

export const reducersRaw = {
  userWatchers: combineReducers({
    uniquesIds: userWatchersUniqueIdsReducer,
    map: userWatchersMapReducer,
  }),
  watchers: combineReducers({
    keys: watchersKeysReducer,
    countsMap: watchersCountsMapReducer,
    queriesMap: watchersQueriesMapReducer,
  }),
  watcherExists: watcherExistsReducer,
};
